class StatusWidget extends HTMLElement {
    constructor(){
        super();
        const {status} = this.dataset;

        this.setStatus(status);
    }

    static get colorMap() {
        return {
            green: ['published', 'live', 'up', 'live+draft', 'complete', 'capture'],
            blue: ['scheduled', 'ready', 'uploading', 'processing', 'ad', 'in adbreak', 'pending', 'in adbreak'],
            orange: ['error'],
            red: ['override capture'],
            black: ['blackout', 'override blackout'],
        };
    }

    setStatus = status => {
        this.dataset.status = status;

        this.innerText = this.parseStatus(status);
    }

    setColor = (color = '') => {
        this.dataset.color = color.toLowerCase();
    }

    changeToDefaultColor = status => {
        const color = Object.keys(StatusWidget.colorMap)
            .filter(key => StatusWidget.colorMap[key].includes(status));

        if (color.length) {
            this.setColor(color[0]);
        } else {
            this.setColor('gray');
        }
    }

    parseStatus = (rawStatus = '') => {
        let status = rawStatus.toLowerCase();
        this.changeToDefaultColor(status);

        const LIVE = 'LIVE';
        const PULLED = 'PULLED';
        const NOTLIVE = 'NOT LIVE';
        const DRAFT = 'DRAFT';
        const PROCESSING = 'PROCESSING';
        const ERROR = 'ERROR';

        const statusMap = {
            published: LIVE,
            up: LIVE,
            unpublished: PULLED,
            notlive: NOTLIVE,
            down: NOTLIVE,
            statusaging: DRAFT,
            pending: PROCESSING,
            error: ERROR,
        };

        if (!status){
            console.error('No status passed in to %o', this);
            status = statusMap.error;
        } else if (!statusMap[status]){
            status = status.toUpperCase();
        } else {
            status = statusMap[status];
        }

        return status;
    }
}

customElements.define('sinclair-status', StatusWidget);
